/** Shared server/browser calendar rules. ISO dates compare as calendar days. */
const CHICAGO = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Chicago",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});
export function chicagoToday(now = new Date()): string {
  const parts = CHICAGO.formatToParts(now);
  const part = (kind: string) => parts.find((p) => p.type === kind)!.value;
  return `${part("year")}-${part("month")}-${part("day")}`;
}
